@if (loading() && loader() === 'spinner') {
  <mat-spinner diameter="20"></mat-spinner>
}
@if (loading() && loader() === 'skeleton') {
  <div>
    <ngx-skeleton-loader
      [theme]="{ height: loaderHeight + 'px', marginBottom: 0 }"
      appearance="line"
    />
  </div>
}
<img
  class="select-none pointer-events-none"
  (load)="onLoad()"
  [alt]="altText()"
  [hidden]="loading()"
  [ngClass]="imgCSSClass()"
  [src]="imgSrc() | srcSecurePipe : errorSrc() | async"
/>
